import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getListNotifications } from "../redux/actions/notificationActions";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const redirect = "/";
  // Get notifications from Redux store
  const { notifications } = useSelector((state) => state.getListNotifications);

  // Count unread notifications
  const unreadNotificationsCount = notifications?.filter(
    (notification) => !notification.is_vu
  )?.length || 0;

  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    } else {
      // Fetch notifications when component mounts
      dispatch(getListNotifications(0));
    }
  }, [navigate, userInfo, dispatch]);

  // We removed the useEffect that was setting openParametrs and openDepenses
  // since those state variables were not being used elsewhere

  return (
    <aside
      className={`absolute left-0 top-0 z-999999 flex h-screen w-72.5 flex-col overflow-y-hidden bg-white shadow-lg rounded-tr-xl rounded-br-xl duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0 ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* <!-- SIDEBAR HEADER --> */}
      <div className="flex items-center justify-between gap-2 px-6 py-5.5 lg:py-6.5 border-b border-gray-200">
        <NavLink to="/dashboard" className="w-full">
          <div className="text-primary font-bold text-xl text-center flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.96 10.25c-1.42 1.92-2.12 2.88-2.7 2.88-.58 0-1.28-.96-2.7-2.88-1.42-1.92-2.12-2.88-1.64-3.84.48-.96 1.94-.96 4.34-.96 2.4 0 3.86 0 4.34.96.48.96-.22 1.92-1.64 3.84z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Express Halal Food
          </div>
        </NavLink>

        <button
          onClick={() => {
            setSidebarOpen(!sidebarOpen);
          }}
          aria-controls="sidebar"
          aria-expanded={sidebarOpen}
          className="block lg:hidden text-primary hover:text-secondary transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      {/* <!-- SIDEBAR HEADER --> */}

      <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
        {/* <!-- Sidebar Menu --> */}
        <nav className="mt-3 py-4 px-4 lg:mt-6 lg:px-6">
          {/* <!-- Menu Group --> */}
          <div>
            {/*  */}
            <div className="text-xs font-semibold text-gray-500 uppercase mb-4 px-2">Main Menu</div>
            <ul className="mb-6 flex flex-col gap-1">
              {/* Dashboard */}

              <li>
                <NavLink
                  to="/dashboard"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("dashboard") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h2a1 1 0 001-1v-7m-6 0a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1" />
                  </svg>
                  Dashboard
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/banners"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("banners") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Banners
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/notifications"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("notifications") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                  Notifications
                  {unreadNotificationsCount > 0 && (
                    <span className="absolute right-4 top-3 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs font-medium text-white">
                      {unreadNotificationsCount}
                    </span>
                  )}
                </NavLink>
              </li>

              <div className="text-xs font-semibold text-gray-500 uppercase mt-6 mb-4 px-2">Restaurant Management</div>

              <li>
                <NavLink
                  to="/stores"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("stores") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                  Restaurants
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/sections"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("sections") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                  Categories
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/products"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("products") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  Menu & Dishes
                </NavLink>
              </li>

              <div className="text-xs font-semibold text-gray-500 uppercase mt-6 mb-4 px-2">Orders & Customers</div>

              <li>
                <NavLink
                  to="/orders"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("orders") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                  </svg>
                  Orders
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/clients"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("clients") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                  Customers
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/drivers"
                  className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                    pathname.includes("drivers") &&
                    "bg-primary bg-opacity-10 text-primary"
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  Drivers
                </NavLink>
              </li>

              <div className="mt-6 pt-4 border-t border-gray-200">
                <li>
                  <NavLink
                    to="/settings"
                    className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-black h-12 rounded-lg transition-all duration-200 hover:bg-primary hover:bg-opacity-10 hover:text-primary ${
                      pathname.includes("settings") || pathname.includes("profile")
                        ? "bg-primary bg-opacity-10 text-primary"
                        : ""
                    }`}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Profile & Settings
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/logout"
                    className={`group relative flex items-center gap-2.5 text-sm py-3 px-4 font-medium text-danger h-12 rounded-lg transition-all duration-200 hover:bg-danger hover:bg-opacity-10 ${
                      pathname.includes("logout") && "bg-danger bg-opacity-10"
                    }`}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    Logout
                  </NavLink>
                </li>
              </div>
            </ul>
          </div>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
